/**
 * Check if two LogIndexes are equal
 *
 * @param {import('./LogIndexType.js').LogIndexType} a
 * @param {import('./LogIndexType.js').LogIndexType} b
 * @returns {boolean}
 */
export function equals(a, b) {
	return a === b;
}
